import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const ConfirmDelete = ({ ShowConfirmDelete, confirmDelete, cancelDelete }) =>
  <React.Fragment>
    <Dialog
      open={ShowConfirmDelete}
      onClose={cancelDelete}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Please confirm delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={cancelDelete}>
          No
        </Button>
        <Button
          color="error"
          variant="outlined"
          onClick={confirmDelete}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>;

export default ConfirmDelete;
